import React, { ReactNode } from 'react'
import searchFilterCookTimeConfig from '@mindfulchefuk/config/searchFilterCookTimeConfig'
import searchFilterRatingConfig from '@mindfulchefuk/config/searchFilterRatingConfig'
import {
  SEARCH_FILTER_COOKINGTIME,
  SEARCH_FILTER_CUISINE,
  SEARCH_FILTER_CUISINE_LIMIT,
  SEARCH_FILTER_SEASON,
  SEARCH_FILTER_PRIMARY_FOOD,
  SEARCH_FILTER_RATING,
} from '@mindfulchefuk/constants'

import { Box, Flex, Grid, Label } from '@mindfulchefuk/design-system'

import { MenuSelect } from './MenuSelect'
import { NumericMenuSelect } from './NumericMenuSelect'
import { ClearRefinementsLink } from './ClearRefinementsLink'
import { TFilterDefaults } from './types'

const Filter = ({
  children,
  label,
}: {
  children?: ReactNode
  label: string
}) => (
  <Box>
    <Label as="div">{label}</Label>
    {children}
  </Box>
)

export const DesktopFilters = ({
  filterDefaults = {},
}: {
  filterDefaults: TFilterDefaults
}) => (
  <Box display={{ base: 'none', md: 'block' }} mb={32}>
    <Grid columnGap={32} templateColumns="repeat(5, 1fr)">
      <Filter label="Food group">
        <MenuSelect
          attribute={SEARCH_FILTER_PRIMARY_FOOD}
          defaultRefinement={filterDefaults[SEARCH_FILTER_PRIMARY_FOOD]}
        />
      </Filter>
      <Filter label="Cuisine">
        <MenuSelect
          attribute={SEARCH_FILTER_CUISINE}
          defaultRefinement={filterDefaults[SEARCH_FILTER_CUISINE]}
          limit={SEARCH_FILTER_CUISINE_LIMIT}
        />
      </Filter>
      <Filter label="Season">
        <MenuSelect
          attribute={SEARCH_FILTER_SEASON}
          defaultRefinement={filterDefaults[SEARCH_FILTER_SEASON]}
        />
      </Filter>
      <Filter label="Cooking time">
        <NumericMenuSelect
          attribute={SEARCH_FILTER_COOKINGTIME}
          items={searchFilterCookTimeConfig}
          defaultRefinement={filterDefaults[SEARCH_FILTER_COOKINGTIME]}
        />
      </Filter>
      <Filter label="Rating">
        <NumericMenuSelect
          attribute={SEARCH_FILTER_RATING}
          items={searchFilterRatingConfig}
          defaultRefinement={filterDefaults[SEARCH_FILTER_RATING]}
        />
      </Filter>
    </Grid>
    <Flex justify="flex-end" mt={8}>
      <ClearRefinementsLink />
    </Flex>
  </Box>
)
